import type { IApiRoutes } from '../ApiRoutes';
import type { GeodataDataType } from '@visualizer/types';

export const ProductionApiRoutes: IApiRoutes = {
    gridDownload(gridId: string): string {
        return `grids/${gridId}/download`;
    },

    geodataDownload(geodataId: string, dataType: GeodataDataType): string {
        switch (dataType) {
            case 'ground':
                return `geodatas/${geodataId}/terrain/download`;
            case 'vegetation':
                return `geodatas/${geodataId}/vegetation/download`;
            case 'buildings':
                return `geodatas/${geodataId}/buildings/download`;
            case 'roads':
                return `geodatas/${geodataId}/roads/download`;
            case 'target':
                return `geodatas/${geodataId}/targets/download`;
            default:
                throw new Error(`Unsupported geodata endpoint kind: ${dataType}`);
        }
    },

    raysDownload(simulationSetId: string, subSimulationId: number, raysAssetKind: string): string {
        return `/api/simulation-sets/${simulationSetId}/simulations/${subSimulationId}/${raysAssetKind}/download`;
    },

    resultDownload(simulationSetId: string, subSimulationId: number, resultId: number): string {
        return `simulation-sets/${simulationSetId}/simulations/${subSimulationId}/results/${resultId}/download`;
    },

    resultsList(simulationSetId: string, subSimulationId: number): string {
        return `simulation-sets/${simulationSetId}/simulations/${subSimulationId}/results`;
    },

    canUseApi(): boolean {
        return true;
    },
};
